import { getSucursalInfo } from "../services/auth";

// Terminology across the whole app is not fixed — it depends on which kind
// of institution the logged-in user's current sucursal is, via 3 flags
// carried on the Sucursal record itself (same place pautaVisivelWhatsapp
// etc. live, see services/config.js / getSucursalInfo()):
//   hasCorse==1              -> vocabulary "Curso"
//   isCollege==1/isSchool==1 -> vocabulary "Classe"
//   none of the above        -> vocabulary "Nível"
const isFlagOn = (value) => value === 1 || value === "1" || value === true;

// `sucursalOverride` lets callers resolve vocabulary for a sucursal other
// than the logged-in one — e.g. RenovacaoInscricaoLayer, where the operator
// can pick a different target sucursal to transfer a student into, and the
// wording (Curso/Classe/Nível) should follow that target, not the session's.
export const getSucursalVocab = (sucursalOverride) => {
  const sucursal = sucursalOverride || getSucursalInfo();
  if (isFlagOn(sucursal?.hasCorse)) return "curso";
  if (isFlagOn(sucursal?.isCollege) || isFlagOn(sucursal?.isSchool)) return "classe";
  return "nivel";
};

export const isCursoSucursal = (sucursalOverride) => getSucursalVocab(sucursalOverride) === "curso";

// For every i18n key that renders "Curso"/"Classe"/"Nível" wording (student,
// propina, turma, disciplina, avaliação, nota/pauta, renovação, taxa,
// dashboard and menu screens), 3 parallel "<key>.curso"/"<key>.classe"/
// "<key>.nivel" entries hold the 3 wordings — this picks whichever one
// applies for the current (or overridden) sucursal.
export const levelKey = (key, sucursalOverride) => `${key}.${getSucursalVocab(sucursalOverride)}`;

// Terminology for ListaClassesLayer/CadastrarClasseLayer (linked from
// Configurações > "Cursos"/"Classes"/"Níveis").
// ListaClassesPage/CadastrarClassePage reuse the `submenu`/`singular` keys
// so the breadcrumb, section heading and "Adicionar"/"Cadastrar" wording
// always match. `isCursos` lets CadastrarClasseLayer show/require the
// "Código"/"Duração" fields only for the Cursos vocabulary — Classes/Níveis
// don't use them.
const CLASSES_LABELS_BY_VOCAB = {
  curso: {
    submenu: "menu.classes.cursos.submenu",
    singular: "menu.classes.cursos.singular",
    isCursos: true,
  },
  classe: {
    submenu: "menu.classes.classes.submenu",
    singular: "menu.classes.classes.singular",
    isCursos: false,
  },
  nivel: {
    submenu: "menu.classes.niveis.submenu",
    singular: "menu.classes.niveis.singular",
    isCursos: false,
  },
};

export const getClassesLabels = () => CLASSES_LABELS_BY_VOCAB[getSucursalVocab()];

export default getClassesLabels;
